import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { Response } from '@/model';
import {
  CreditExtraPurchaseResult,
  CreditPricing,
  CreditStatus,
  PaymentCardInfo,
  PaymentInfo
} from '@/model/BillingPlan';
import BillingApi from '@/api/BillingApi';

type StateProps = {
  current?: PaymentInfo,
  cardInfo?: PaymentCardInfo,
  creditStatus?: CreditStatus,
  creditPricing?: CreditPricing
};

const initialState: StateProps = {
  current: undefined,
  cardInfo: undefined,
  creditStatus: undefined,
  creditPricing: undefined
};

export const settingBillingThunk = {
  getCurrentPaymentInfo: createAsyncThunk(
    'settingBilling/getCurrentPaymentInfo',
    async () => {
      const response = await BillingApi.getPaymentInfo();
      return response?.data?.result;
    }
  ),
  getBindCardInfo: createAsyncThunk(
    'settingBilling/getBindCardInfo',
    async () => {
      const response = await BillingApi.getBindCardInfo();
      return response?.data?.result;
    }
  ),
  getCreditStatus: createAsyncThunk(
    'settingBilling/getCreditStatus',
    async () => {
      const response = await BillingApi.getCreditStatus();
      return response?.data?.code === 200 ? response?.data?.result : undefined;
    }
  ),
  getCreditPricing: createAsyncThunk(
    'settingBilling/getCreditPricing',
    async () => {
      const response = await BillingApi.getCreditPricing();
      return response?.data?.code === 200 ? response?.data?.result : undefined;
    }
  ),
  buyExtraCredits: createAsyncThunk(
    'settingBilling/buyExtraCredits',
    async ({ amountUsd }: { amountUsd: number }): Promise<AxiosResponse<Response<CreditExtraPurchaseResult>>> => {
      try {
        return await BillingApi.buyExtraCredits({ amountUsd });
      } catch (error: any) {
        return error?.response;
      }
    }
  ),
  toggleExtraCredits: createAsyncThunk(
    'settingBilling/toggleExtraCredits',
    async ({ enable }: { enable: boolean }): Promise<AxiosResponse<Response<null>>> => {
      try {
        return await BillingApi.toggleExtraCredits({ enable });
      } catch (error: any) {
        return error?.response;
      }
    }
  )
};

export const settingBillingReducer = createSlice({
  name: 'SettingBillingSlice',
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder.addCase(
      settingBillingThunk.getCurrentPaymentInfo.fulfilled,
      (state, action: PayloadAction<PaymentInfo | undefined>) => {
        state.current = action.payload;
      }
    );
    builder.addCase(
      settingBillingThunk.getBindCardInfo.fulfilled,
      (state, action: PayloadAction<PaymentCardInfo | undefined>) => {
        state.cardInfo = action.payload;
        // if (action.payload?.last4) {
        // } else {
        //   state.cardInfo = undefined;
        // }
      }
    );
    builder.addCase(
      settingBillingThunk.getCreditStatus.fulfilled,
      (state, action: PayloadAction<CreditStatus | undefined>) => {
        state.creditStatus = action.payload;
      }
    );
    builder.addCase(
      settingBillingThunk.getCreditPricing.fulfilled,
      (state, action: PayloadAction<CreditPricing | undefined>) => {
        state.creditPricing = action.payload;
      }
    );
  }
});

export default settingBillingReducer.reducer;

export const settingBillingActions = settingBillingReducer.actions;
